/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit StateText/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function StateText({
  children,
  viewPath = "/DesignSystem/AppointmentBookingStateTextWithIcon/StateText",
  size
  
}) {
let selectedStateValueData = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'state',
format: fromFormat.getStateText,
})
let selectedShowIconValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'show_icon',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size={size}
 data="selected.state"
 format="/Data/format.js getStateText"
 text={selectedStateValueData}
 marginLeft={selectedShowIconValueData ? dtSpaceXxs : "0px"}
 data="selected.show_icon"
/>
{children}
</React.Fragment>)
}